const dataLayerViewProductDetails = function() {
    if (!window.dataLayer) {
        console.error("dataLayerViewProductDetails: DataLayer not available")
        return
    }

    const DOM = document.querySelector('script[type="nordlux/tracking"]')

    if (!DOM) {
        return
    }
    dataLayer.push(JSON.parse(DOM.innerText))
}

const dataLayerAddToCart = function(productData = { quantity: 1 }) {
    if (!window.dataLayer) {
        console.error("dataLayerAddToCart: DataLayer not available")
        return
    }

    const DOM = document.querySelector('script[type="nordlux/tracking"]')

    if (DOM) {
        let dataFromDOM = JSON.parse(DOM.innerText)
        const lineItem = dataFromDOM.ecommerce.items && dataFromDOM.ecommerce.items[0]
        const lineItemAmount = lineItem && lineItem.price || 0
        Object.assign(dataFromDOM.ecommerce, { value: lineItemAmount * productData.quantity })
        dataFromDOM.event = 'add_to_cart'
        dataFromDOM.ecommerce.items[0].quantity = productData.quantity
        console.log("dataLayerAddToCart - PDP: Push to datalyer", dataFromDOM)
        dataLayer.push(dataFromDOM)
        return
    }

    const dataFromProductData = {
        event: "add_to_cart",
        ecommerce: {
            currency: productData && productData.price && productData.price.currency || "",
            value: (productData && productData.price && productData.price.amount || 0) * productData.quantity,
            items: [{
                currency: productData && productData.price && productData.price.currency || "",
                index: 0,
                item_brand: productData && Array.isArray(productData.brand) && productData.brand[0] || "",
                item_category: "",
                item_category2: "",
                item_category3: "",
                item_id: productData && productData.productSku || "",
                item_name: productData && productData.displayName || "",
                item_variant: productData && productData.displayName || "",
                price: productData && productData.price && productData.price.amount || 0,
                quantity: productData.quantity
            }]
        }
    }
    dataLayer.push(dataFromProductData)

}

const dataLayerCheckout = function(cartData) {
    if (!window.dataLayer) {
        console.error("dataLayerCheckout: DataLayer not available")
        return
    }

    const dataFromProductData = {
        event: "begin_checkout",
        ecommerce: {
            currency: cartData && cartData.currency || "",
            value: cartData.subTotalAmount,
            items: cartData.orderLines.map(product => {
                return {
                    index: 0,
                    item_brand: product.brand,
                    item_category: "",
                    item_id: product.productSku,
                    item_name: product.productName,
                    item_variant: product.productName,
                    price: product.unitPriceAmount,
                    quantity: product.quantity
                }
            })
        }
    }
    dataLayer.push(dataFromProductData)

}

const dataLayerPurchase = function(cartData) {
    if (!window.dataLayer) {
        console.error("dataLayerPurchase: DataLayer not available")
        return
    }

    const dataFromProductData = {
        event: "purchase",
        ecommerce: {
            currency: cartData && cartData.currency || "",
            transaction_id: "",
            affiliation: "online store",
            value: cartData.orderTotalAmount,
            tax: cartData.taxAmount,
            shipping: cartData.shippingTotalAmount,
            currency: cartData.currency,
            coupon: "",
            items: cartData.orderLines.map(product => {
                return {
                    index: 0,
                    item_brand: product.brand,
                    item_category: "",
                    item_id: product.productSku,
                    item_name: product.productName,
                    item_variant: product.productName,
                    price: product.unitPriceAmount,
                    quantity: product.quantity
                }
            })
        }
    }
    dataLayer.push(dataFromProductData)
}

export {
    dataLayerViewProductDetails,
    dataLayerAddToCart,
    dataLayerCheckout,
    dataLayerPurchase
}